import { type FunctionComponent, type ReactNode } from "react";

import { useHomepageMidPageQueueTopic } from "scmp-app/components/homepage-mid-page-recommendation/queue-topic-hooks";
import type { fallbackQueryLoaderQuery$data } from "scmp-app/queries/__generated__/fallbackQueryLoaderQuery.graphql";

import type { MidPageQueueData } from "./types";

type Props = {
  fallbackData: unknown;
  onQueueData: (data: MidPageQueueData) => ReactNode;
};

/**
 * Reads the fallback query's queue data for the story-package slots.
 *
 * The per-slot edges fragments are `@include`-gated in the fallback query
 * (SCMPWEB-9641): a slot left on AI by the app-config is excluded from the
 * fetch, so its queue fields are absent (`undefined`) on the response. The
 * topic hook's optional chaining degrades those to empty edges / no topic —
 * no Relay "fragment reference was not found" invariant.
 *
 * Must only be mounted when the fallback query was actually loaded
 * (`fallbackData != null`).
 */
export const MidPageWidgetsQueueData: FunctionComponent<Props> = ({
  fallbackData,
  onQueueData,
}) => {
  const queueData = useHomepageMidPageQueueTopic(fallbackData as fallbackQueryLoaderQuery$data);
  return <>{onQueueData(queueData)}</>;
};

MidPageWidgetsQueueData.displayName = "MidPageWidgetsQueueData";
